import React, {useState} from 'react';
import {Button, message} from 'antd';
import {DownloadOutlined} from '@ant-design/icons';
import {saveAs} from 'file-saver';
import {downloadFile, saveFileFromURL} from "../../services/api.service";

const OutputFile = ({file, type}) => {
    const [loader, setLoader] = useState(false);


    const downloadOutputFile = async () => {
        try {
            if (file) {
                setLoader(true);
                const fileString = file.split('/');
                const fileName = encodeURI(fileString[fileString.length - 1]);
                const {data: {data}} = await downloadFile(fileName, type);
                await downloadURI(data, fileName);
                setLoader(false);
            }
        } catch (err) {
            setLoader(false);
            message.error('Failed to download file');
        }
    };

    const downloadURI = async (url, name) => {
        try {
            const {data} = await saveFileFromURL(url);
            saveAs(data, name);
        } catch (err) {
            throw err;
        }
        // const xhr = new XMLHttpRequest();
        // xhr.open("GET", uri);
        // xhr.responseType = "blob";
        // xhr.onload = function () {
        //     saveAs(this.response, name); // saveAs is a part of FileSaver.js
        // };
        // xhr.send();
    };

    return (
        <React.Fragment>
            <Button onClick={downloadOutputFile} loading={loader} type="default" shape="round"
                    icon={<DownloadOutlined/>}/>
        </React.Fragment>
    )
};

export default OutputFile;